import * as types from '@/store/mutation-types'
import axios from 'axios/index'

const state = {
  token: localStorage.getItem('token') || '',
  status: ''
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status
}

const mutations = {
  [types.AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [types.AUTH_SUCCESS]: (state, token) => {
    state.status = 'success'
    state.token = token
  },
  [types.AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [types.AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

const actions = {
  [types.AUTH_REQUEST]: ({commit, dispatch}, credentials) => {
    return new Promise((resolve, reject) => {
      commit(types.AUTH_REQUEST)
      axios({url: 'login', data: credentials, method: 'POST'})
        .then(resp => {
          const token = resp.data.token
          localStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          commit(types.AUTH_SUCCESS, token)

          dispatch(types.FETCH_USER)
          resolve(resp)
        })
        .catch(err => {
          commit(types.AUTH_ERROR, err)
          localStorage.removeItem('token')
          reject(err)
        })
    })
  },
  [types.AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('token')
      localStorage.removeItem('profile')
      localStorage.clear()
      sessionStorage.clear()
      commit(types.AUTH_LOGOUT)
      resolve()
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js